import { useMutation } from "@apollo/client";
import { css } from "@emotion/css";
import { ButtonWithGradient, Dialog, Text } from "components";
import { upperFirst } from "lodash";
import { T_Integration } from "types";
import { REMOVE_INTEGRATION } from "apollo";

interface Props {
  open?: boolean;
  type: T_Integration;
  integrationId: string;
  onOpenChange?(open: boolean): void;
}
export function RemoveDialog(props: Props) {
  const [removeIntegration, { loading }] = useMutation(REMOVE_INTEGRATION);

  const onRemoveAuth = () => {
    removeIntegration({
      variables: {
        integration: {
          id: props.integrationId,
          type: props.type,
        },
      },
    }).then(async (res) => {
      props.onOpenChange?.(false);
    });
  };

  return (
    <Dialog
      noClose
      additionalContent={
        <div
          className={css`
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 70px;
          `}
        >
          <div
            className={css`
              width: 500px;
              margin-bottom: 24px;
              display: flex;
              flex-direction: column;
              align-items: center;
            `}
          >
            <Text.H2>Remove integration for {upperFirst(props.type)}?</Text.H2>

            <Text.Body style={{ color: "#838094", textAlign: "center" }}>
              This may limit Multiplayer performance. You can always reconnect
              from the settings panel.
            </Text.Body>
          </div>
          <div
            className={css`
              display: grid;
              grid-template-columns: auto auto;
              gap: 13px;
              width: 100%;
            `}
          >
            <ButtonWithGradient onClick={() => props.onOpenChange?.(false)}>
              Cancel
            </ButtonWithGradient>

            <ButtonWithGradient onClick={onRemoveAuth} disabled={loading}>
              Confirm
            </ButtonWithGradient>
          </div>
        </div>
      }
      open={props.open}
      onOpenChange={props.onOpenChange}
    />
  );
}
